import defaultSettings from '@/settings'

const title = defaultSettings.title || '浙江东卫文青教育科技有限公司';

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}